import { createSelector } from 'reselect';
import { ClassType } from '@lingoda/graphql';
import studentCreditsSelector from './credits';

export default createSelector(
    studentCreditsSelector,
    (credits) => credits[ClassType.Individual] + credits[ClassType.Group],
);
